import { render, staticRenderFns } from "./luoshaTable.vue?vue&type=template&id=c0a1367a&scoped=true"
import script from "./luoshaTable.vue?vue&type=script&lang=js"
export * from "./luoshaTable.vue?vue&type=script&lang=js"
import style0 from "./luoshaTable.vue?vue&type=style&index=0&id=c0a1367a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a1367a",
  null
  
)

export default component.exports